import React from 'react';

// Styles & Assets
import styles from './Icon.module.css';

// Icon: renders a 24x24px icon in a 40x40px container.
// Received props:
//  -children: the Icon component has to wrap the Icon in the parent.
//  -color: optional prop to indicate the color of the icon.
const Icon: React.FC<{
    children: React.ReactNode,
    size?: number,
    color?: string,
}> = ({ children, size, color }) => {

    
    return (
        <div 
            className={styles.iconWrapper} 
            style={{ 
                color: color,
                height: size+'px',
                width: size+'px',
                padding: size ? size/5+'px': undefined
            }}
        >
            {children}
        </div>
    );
};

export default Icon;